import RemoteApi from './BaseRemoteApi'
import { Session } from '../components/ResourceSelector/model';

export default class APIPlatformRemoteApi extends RemoteApi {

    constructor(authorization: string) {
        super('/apiplatform', authorization)
    }

    getAPIPlatformToken(): Promise<Session> {
        const token = this.authorization.replace('Bearer ', '');
        return this._post(['session'], {token: token}, true);
    }
}
